import { render, staticRenderFns } from "./helpLink.vue?vue&type=template&id=a61ea8c8&scoped=true"
import script from "./helpLink.vue?vue&type=script&lang=js"
export * from "./helpLink.vue?vue&type=script&lang=js"
import style0 from "./helpLink.vue?vue&type=style&index=0&id=a61ea8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61ea8c8",
  null
  
)

export default component.exports